// src/pages/Help.jsx
import React from "react";
import { useNavigate } from "react-router-dom";

export default function Help() {
  const navigate = useNavigate();

  return (
    <div className="min-h-[100dvh] bg-gradient-to-b from-[#9BE7FF] via-[#FDF7FF] to-[#FFE8C7] px-4 py-6">
      <div className="max-w-3xl mx-auto bg-white/90 rounded-[28px] shadow-2xl border border-white/80 p-5 sm:p-7">
        <div className="flex items-center justify-between gap-3">
          <h1 className="text-xl sm:text-2xl font-black text-slate-900">❓ Help</h1>
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="px-4 py-2 rounded-full bg-slate-900 text-white text-xs font-extrabold"
          >
            Back
          </button>
        </div>

        <div className="mt-4 space-y-4 text-sm sm:text-base text-slate-700">
          <div>
            <div className="font-black text-slate-900">1) Preview the song (before you start)</div>
            <div className="mt-1">
              If you see <span className="font-extrabold">“Preview Song”</span>, tap it to hear the melody once.
              As soon as you press <span className="font-extrabold">Play Now</span>, preview disappears so it never
              interferes with mic play.
            </div>
          </div>

          <div>
            <div className="font-black text-slate-900">2) Start the level</div>
            <div className="mt-1">
              Tap <span className="font-extrabold">🎤 Play Now</span>. Then either:
              <ul className="list-disc ml-5 mt-2">
                <li>Play on a real piano (mic ON), or</li>
                <li>Use the on-screen virtual piano.</li>
              </ul>
            </div>
          </div>

          <div>
            <div className="font-black text-slate-900">3) Mic vs Virtual Piano</div>
            <div className="mt-1">
              If you start using the virtual piano while mic is on, Piano With Pan switches to virtual mode and locks the mic
              until you restart (so nothing gets confused).
            </div>
          </div>

          <div>
            <div className="font-black text-slate-900">4) Show key glow (hint)</div>
            <div className="mt-1">
              This highlights the next correct key. It remembers your choice across levels and sessions.
            </div>
          </div>

          <div>
            <div className="font-black text-slate-900">5) Trophies + Song Book</div>
            <div className="mt-1">
              <span className="font-extrabold">Trophies</span> shows your runs and tiers.
              <br />
              <span className="font-extrabold">Song Book</span> shows unlocked songs (based on completed levels).
            </div>
          </div>

          <div className="pt-2">
            <div className="text-xs text-slate-500">
              Tip: If anything feels stuck, hit <span className="font-extrabold">Restart level</span>.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}